import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';

@Component({
    selector: 'app-sidebar-container',
    templateUrl: './sidebar-container.component.html',
    styleUrls: ['./sidebar-container.component.scss'],
    imports: [NgClass, ExtendedModule, RouterOutlet]
})
export class SidebarContainerComponent implements OnInit {

  title = '';
  isVisible = false;

  constructor(private router: Router,
              private activeRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  show(title) {
    this.title = title;
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
    this.router.navigate(['..'], { relativeTo: this.activeRoute });
  }
}
